import React, { useEffect, useState } from "react";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";
import PropTypes from "prop-types";
import toast from "utils/toast";
import { Controller, useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, InputLabel, Select } from "@mui/material";
import Grid from "@mui/material/Grid";
import { capkMasterModel, capkMasterSchema } from "../../../../models/binMaster";
import ConfiguratorRoot from "../../../../examples/Configurator/ConfiguratorRoot";
import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";
import MDInput from "../../../../components/MDInput";
import MDButton from "../../../../components/MDButton";
import useApi from "../../../../components/Utils/api";
import OutlinedInput from "@mui/material/OutlinedInput";


function CapkConfigurator({openConfigurator, setOpenConfigurator, master, getMasters}) {
  // const [controller] = useMaterialUIController();
  // const {user} = controller;
  const [merchants, setMerchants] = useState([]);
  const [defaultMasters, setDefaultMasters] = useState([]);
  const { register, handleSubmit, reset, formState: { errors }, trigger, watch, control, setValue } = useForm({
    mode: "onChange",
    resolver: yupResolver(capkMasterSchema)
  });
  useEffect(() => {
  
    if(Object.keys(master).length > 0 ){
      reset(master);
    } else {
      
      reset(capkMasterModel);
    }

  }, [master])
  const api = useApi();


  const createTerminalHandler = (data) => {
    api.post("master/createcapkMaster", data)
      .then((response) => {
        if(response.status === 200){
          toast.success("Capk master successfully created.");
          setOpenConfigurator(false);
          getMasters();
        }
      })
      .catch((error) => {
          if (error.response && error.response.status === 403) {
              toast.error("You do not have permission to perform this action.");
              return;
          }
        console.log(error.response);
        if (error.response.status === 406){
          toast.error(error.response.data.body)
        }
      })
  }
  function updateTerminalHandler(data) {
    api.put("master/updateCapk", data)
      .then(response => {
        if(response.data.statusCodeValue === 200) {
          toast.success("Capk master successfully updated.");
          reset(capkMasterModel);
          setOpenConfigurator(false);
          getMasters();
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
  function submitHandler() {
    if(Object.keys(master).length === 0 ){
      handleSubmit(createTerminalHandler)();
    } else {
      handleSubmit(updateTerminalHandler)();
    }
  }

  return (
    <ConfiguratorRoot variant="permanent" ownerState={{ openConfigurator }} configuratorwidth={500}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="baseline"
        pt={4}
        pb={0.5}
        px={3}
      >
        <MDBox>
          <MDTypography variant="h5">{Object.keys(master).length > 0 ? 'Update' : 'New'} CAPK Master</MDTypography>
          {/*<MDTypography variant="body2" color="text">*/}
          {/*  {updatedUser?.userId}*/}
          {/*</MDTypography>*/}
        </MDBox>

        <Icon
          sx={({ typography: { size }, palette: { dark, white } }) => ({
            fontSize: `${size.lg} !important`,
            color: dark.main,
            stroke: "currentColor",
            strokeWidth: "2px",
            cursor: "pointer",
            transform: "translateY(5px)",
          })}
          onClick={() => setOpenConfigurator(false)}
        >
          close
        </Icon>
      </MDBox>
      <Divider />
      <Grid container spacing={2} justifyContent="center">
        <FormProvider {...{ register, handleSubmit, reset, formState: { errors }, trigger, watch, control }}>
          

        <Grid item xs={6}>
            <MDInput
              type="text"
              label="Description"
              name="description"
              error={errors.description}
              helperText={errors.description ? errors.description.message : ''}
              fullWidth
              required
              {...register("description")}
            />
          </Grid>

          <Grid item xs={6}>
            <MDInput
              type="text"
              label="Rid"
              name="rid"
              error={errors.rid}
              helperText={errors.rid ? errors.rid.message : ''}
              fullWidth
              required
              {...register("rid")}
            />
          </Grid>
          

          <Grid item xs={6}>
            <MDInput
              type="text"
              label="Rid Index"
              name="ridIndex"
              error={errors.ridIndex}
              helperText={errors.ridIndex ? errors.ridIndex.message : ''}
              fullWidth
              required
              {...register("ridIndex")}
            />
          </Grid>

          <Grid item xs={6}>
            <MDInput
              type="text"
              label="EXPONENT"
              name="exponent"
              error={errors.exponent}
              helperText={errors.exponent ? errors.exponent.message : ''}
              fullWidth
           
              {...register("exponent")}
            />
          </Grid>

          <Grid item xs={6}>
            <MDInput
              type="text"
              label="Modulus"
              name="modulus"
              error={errors.modulus}
              helperText={errors.modulus ? errors.modulus.message : ''}
              fullWidth
          
              {...register("modulus")}
            />
          </Grid>


        


          <Grid item xs={6}>
            <MDInput
              type="text"
              label="Sha1"
              name="sha1"
              error={errors.sha1}
              helperText={errors.sha1 ? errors.sha1.message : ''}
              fullWidth
           
              {...register("sha1")}
            />
          </Grid>
          <Grid item xs={6}>
            <MDInput
              type="text"
              label="Expires"
              name="expires"
              error={errors.expires}
              helperText={errors.expires ? errors.expires.message : ''}
              fullWidth
           
              {...register("expires")}
            />
          </Grid>

        

          <Grid item xs={12}>
            <MDButton onClick={() => submitHandler()} variant="gradient" color="info" style={{float : 'right'}}>
              {Object.keys(master).length > 0 ? 'Update' : 'Add'}
            </MDButton>
          </Grid>
        </FormProvider>
      </Grid>
    </ConfiguratorRoot>
  );
}

CapkConfigurator.defaultProps = {
  openConfigurator: false,
  setOpenConfigurator: false,
  getMasters: false,
  master : {}
}

CapkConfigurator.propTypes = {
  openConfigurator: PropTypes.bool,
  setOpenConfigurator: PropTypes.func,
  getMasters: PropTypes.func,
  master: PropTypes.object
}

export default CapkConfigurator;